import initialize_feedback_form from "../../shared/utils/initialize_feedback_form";

export default function(form_identifier, revocationUrl) {
  initialize_feedback_form(form_identifier, revocationUrl, (formContainer, data) => {
    const submissionDatetime = new Date(data.confirmation.submitted_at);
    const prettySubmissionDate = submissionDatetime.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
    const prettySubmissionTime = submissionDatetime.toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit"
    });

    formContainer.innerHTML = `<br>
      <h1>Widerruf erfolgreich übermittelt</h1>
      <p>Vielen Dank. Wir haben Ihren Widerruf erhalten. Ihre Erklärung wurde am ${prettySubmissionDate} um ${prettySubmissionTime} Uhr erfolgreich an uns übermittelt.<br>
        So geht es weiter: Wir bearbeiten Ihren Widerruf umgehend. Eine automatisierte Eingangsbestätigung mit allen Details wurde soeben an Ihre E-Mail-Adresse ${data.confirmation.email} gesendet.<br>
        Falls Sie bereits Zahlungen für diese Fortbildung geleistet haben, erstatten wir Ihnen den Betrag innerhalb der gesetzlichen Frist über das ursprüngliche Zahlungsmittel zurück.</p>
      <p>Ihr Team der BDC|eAkademie</p>`;
  });
}
